import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-428ea38e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-h6 my-2" }, "Clasificación por Equipos", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Equipo"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos a favor"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos en contra"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Diferencia"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "G. Muertos")
  ])
], -1))
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Esperando resultados...", -1))
const _hoisted_13 = [
  _hoisted_12
]

import { EquipoDTO } from "@/interfaces/Inscripcion";
import { PartidaTorneoDTO } from "@/interfaces/Partidas";
import { ClasificacionEquipo, Torneo } from "@/interfaces/Torneo";
import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabClasificacionEquipos',
  props: {
    tabClasificacion: {},
    activeTab: {},
    torneo: {},
    partidas: {},
    equipos: {}
  },
  emits: ["enviarClasificacion"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const clasificacionEquipos = ref<ClasificacionEquipo[]>([]);

watch(
  [() => props.equipos, () => props.partidas],
  ([equipos, partidas]) => {
    if ((equipos?.length ?? 0) > 0 && (partidas?.length ?? 0) > 0) {
      generarClasificacionEquipos();
    }
  },
  { immediate: true }
);

function generarClasificacionEquipos() {
  const equipos = props.equipos ?? [];
  const partidas = props.partidas ?? [];

  const clasificacionMap = new Map<number, ClasificacionEquipo>();

  equipos.forEach((equipo) => {
    clasificacionMap.set(equipo.idEquipo, {
      nombreEquipo: equipo.nombreEquipo ?? `Equipo ${equipo.idEquipo}`,
      idEquipo: equipo.idEquipo,
      puntos: 0,
      puntosFavor: 0,
      puntosContra: 0,
      diferencia: 0,
      lideresMatados: 0,
    });
  });

  partidas.forEach((partida) => {
    const {
      idEquipo1,
      idEquipo2,
      resultadoUsuario1,
      resultadoUsuario2,
      partidaValidadaUsuario1,
      partidaValidadaUsuario2,
      liderMuertoUsuario1,
      liderMuertoUsuario2,
    } = partida;

    const esValida = partidaValidadaUsuario1 && partidaValidadaUsuario2;
    if (!esValida || idEquipo1 === null || idEquipo2 === null) return;

    // Acumulamos datos para equipo 1
    const equipo1 = clasificacionMap.get(idEquipo1);
    const equipo2 = clasificacionMap.get(idEquipo2);

    const res1 = resultadoUsuario1 ?? 0;
    const res2 = resultadoUsuario2 ?? 0;

    // Empate
    if (res1 === res2) {
      if (equipo1) equipo1.puntos += 1;
      if (equipo2) equipo2.puntos += 1;
    } else {
      if (equipo1 && res1 > res2) equipo1.puntos += 3;
      if (equipo2 && res2 > res1) equipo2.puntos += 3;
    }

    if (equipo1) {
      equipo1.puntosFavor += res1;
      equipo1.puntosContra += res2;
      if (liderMuertoUsuario2 === true) equipo1.lideresMatados += 1;
      equipo1.diferencia = equipo1.puntosFavor - equipo1.puntosContra;
    }

    if (equipo2) {
      equipo2.puntosFavor += res2;
      equipo2.puntosContra += res1;
      if (liderMuertoUsuario1 === true) equipo2.lideresMatados += 1;
      equipo2.diferencia = equipo2.puntosFavor - equipo2.puntosContra;
    }
  });

  clasificacionEquipos.value = Array.from(clasificacionMap.values()).sort(
    (a, b) => {
      if (b.puntos !== a.puntos) return b.puntos - a.puntos;
      if (b.diferencia !== a.diferencia) return b.diferencia - a.diferencia;
      if (b.puntosFavor !== a.puntosFavor) return b.puntosFavor - a.puntosFavor;
      return b.lideresMatados - a.lideresMatados;
    }
  );

  emit("enviarClasificacion", clasificacionEquipos.value);
}

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_window_item = _resolveComponent("v-window-item")!

  return (_openBlock(), _createBlock(_component_v_window_item, {
    value: _ctx.tabClasificacion,
    key: _ctx.tabClasificacion
  }, {
    default: _withCtx(() => [
      (clasificacionEquipos.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            (_ctx.activeTab === _ctx.tabClasificacion)
              ? (_openBlock(), _createBlock(_component_v_table, {
                  key: 0,
                  density: "compact"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clasificacionEquipos.value, (equipo, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: equipo.idEquipo
                        }, [
                          _createElementVNode("td", _hoisted_4, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", _hoisted_5, _toDisplayString(equipo.nombreEquipo), 1),
                          _createElementVNode("td", _hoisted_6, _toDisplayString(equipo.puntos), 1),
                          _createElementVNode("td", _hoisted_7, _toDisplayString(equipo.puntosFavor), 1),
                          _createElementVNode("td", _hoisted_8, _toDisplayString(equipo.puntosContra), 1),
                          _createElementVNode("td", _hoisted_9, _toDisplayString(equipo.diferencia), 1),
                          _createElementVNode("td", _hoisted_10, _toDisplayString(equipo.lideresMatados), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
    ]),
    _: 1
  }, 8, ["value"]))
}
}

})